import React from 'react'
import { Radio, Row, Col } from 'antd'
import ReportsPage from './Reports'
import { RepairsByUserTab } from './RepairsByUser'
import { injectIntl } from 'react-intl'
import { requireAuthentication } from '../helpers/authentication'
import { useCheckPermission } from '../hooks/Permissions'

const ReportContainer = ({ intl }) => {
  const checkPermission = useCheckPermission()
  const hasRepairsByUserViewPermission = checkPermission(
    'report-repairs-by-user:get',
  )
  const hasFaultReportPermission = checkPermission('page-fault-report:get')
  const [tab, setTab] = React.useState('report')

  if (!hasFaultReportPermission) {
    return (
      <div>
        Access Denied: You do not have permission to view fault reports.
      </div>
    )
  }

  return (
    <div id="report-monitor-container">
      <Row style={{ margin: '24px' }}>
        <Col span={8} />
        <Col span={8}>
          <Radio.Group
            options={[
              { label: 'Report', value: 'report' },
              { label: 'Monitoring', value: 'monitoring' },
              ...(hasRepairsByUserViewPermission
                ? [{ label: 'Repairs by User', value: 'repairs-by-user' }]
                : []),
            ]}
            onChange={(e) => setTab(e.target.value)}
            value={tab}
            optionType="button"
            block
            buttonStyle="solid"
            style={{ marginBottom: '16px' }}
          />
        </Col>
        <Col span={8} />
      </Row>
      <Row style={{ height: '100%' }}>
        <Col span={24} id="reports-page-container">
          {tab === 'repairs-by-user' ? (
            <RepairsByUserTab />
          ) : (
            <ReportsPage intl={intl} isMonitor={tab === 'monitoring'} />
          )}
        </Col>
      </Row>
    </div>
  )
}

export default requireAuthentication(injectIntl(ReportContainer))
